// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Cosmos Unchained API
 * Provides access to cosmos chain data.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Value } from './Value';
import {
    ValueFromJSON,
    ValueFromJSONTyped,
    ValueToJSON,
} from './Value';

/**
 * Contains info about an unbonding action
 * @export
 * @interface UnbondingEntry
 */
export interface UnbondingEntry {
    /**
     * 
     * @type {Value}
     * @memberof UnbondingEntry
     */
    balance: Value;
    /**
     * 
     * @type {string}
     * @memberof UnbondingEntry
     */
    completionTime: string;
}

/**
 * Check if a given object implements the UnbondingEntry interface.
 */
export function instanceOfUnbondingEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "balance" in value;
    isInstance = isInstance && "completionTime" in value;

    return isInstance;
}

export function UnbondingEntryFromJSON(json: any): UnbondingEntry {
    return UnbondingEntryFromJSONTyped(json, false);
}

export function UnbondingEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnbondingEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'balance': ValueFromJSON(json['balance']),
        'completionTime': json['completionTime'],
    };
}

export function UnbondingEntryToJSON(value?: UnbondingEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'balance': ValueToJSON(value.balance),
        'completionTime': value.completionTime,
    };
}

